import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/feature-requests/")({
  staticData: {
    breadcrumb: false,
  },
  component: FeatureRequestsIndexRoute,
})

function FeatureRequestsIndexRoute() {
  return null
}
